/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pos_Lot_LoadingInputs */

const vi_pos_lot_loading = /** @type {(inputs: Pos_Lot_LoadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Đang gợi ý lô…`)
};

/**

* @param {Pos_Lot_LoadingInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const pos_lot_loading = /** @type {((inputs?: Pos_Lot_LoadingInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pos_Lot_LoadingInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_pos_lot_loading(inputs)
});